import React from "react";
import { useRef } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Buttons from "./Buttons";
import Confirmation from "./Confirmation";
import NotFound from "./NotFound";
import Verification from "./Verification";
import Support from "./Support";
import Loader from "./Loader";
import Header from "./Header";
import SubmissionStatus from "./SubmissionStatus";

const Layout = (props) => {
	const iframeRef = useRef(null);
	return (
		<>
			{window.location.pathname !== "/loader" && <Header iframeRef={iframeRef} />}
			<Routes>
				<Route path="/" element={<Home />} />
				{/* <Route path="/:trackid" element={<Buttons />} />	 */}
				<Route path="/buttons/:trackid" element={<Buttons />} />
				<Route path="/confirmation" element={<Confirmation />} />
				<Route path="/notfound" element={<NotFound />} />
				<Route path="/verification" element={<Verification iframeRef={iframeRef} />} />
				<Route path="*" element={<Home />} />
				<Route path="/support" element={<Support />} />
				<Route path="/loader" element={<Loader />} />
				<Route path="/status" element={<SubmissionStatus />} />
			</Routes>
		</>
	);
};

export default Layout;
